import React from 'react';
import styled from 'styled-components';

import { QuestionPromptIcon } from '~/atomic/atom/icon/QuestionPromptIcon';
import { Popover } from '~/atomic/atom/Popover';
import { TextRegStyle } from '~/atomic/Typography';
import { isMobileSizeSelector } from '~/feature/media/windowSize.selector';
import { useAppSelector } from '~/store';

export const AbonnementPrompt = () => {
  const isMobileSize = useAppSelector(isMobileSizeSelector);

  return (
    <SCPopover
      header={<SCQuestionPromptIcon />}
      position={isMobileSize ? 'centerRight' : 'centerTop'}
      trigger="hover"
      innerStyle={{ padding: '12px 16px' }}
      contentStyle={{ maxWidth: '220px' }}
    >
      <SCPromptText>
        При открытии платных глав с вашего Абонемента будет списываться
        один раз их объем в знаках до тех пор, пока весь лимит Абонемента не будет израсходован.
      </SCPromptText>
    </SCPopover>
  );
};

const SCQuestionPromptIcon = styled(QuestionPromptIcon)`
  font-size: 15px;
  color: #333333;
  cursor: pointer;
`;

const SCPromptText = styled.span`
  ${TextRegStyle};
  font-size: 13px;
  line-height: 15px;
  color: var(--black-color);
`;

const SCPopover = styled(Popover)`
  display: inline-flex;
  margin-left: 4px;
`;
